import mixpanel from 'mixpanel-browser';
import React from 'react';
import styles from './Onboarding.module.css';
import Topbar from './Topbar';

mixpanel.init("fce1521d323a955b4738b2588097761a", { debug: true, persistence: 'localStorage', ignore_dnt: true, });

const EngageWithPeopleWhoMatter = () => {
    const trackEvent = () => {
        mixpanel.track(
            "Onboarding",
            {
                "origin": "Engage with People who Mattercosystem",
                "navigate": "Optimize Your Nurturing Efforts"
            }
        );
    }
    return (
        <div >
        <div >
            <Topbar/>
            <div className={`${styles['main']} ${styles['center-align']}`}>
                <h3 style={{color:"#2F3EAC"}}>Engage With People Who Matter</h3>
                <p><b>– not whoever LinkedIn wants you to see on your feed.</b></p>
                <div className={`${styles['frow']} `} style={{justifyContent:"normal"}}>
                    <div style={{width:"100%"}}><iframe width="800" height="500" src="https://www.youtube.com/embed/eQ4fhRGOPV4?si=X-bWjPJEqmK5PMws&autoplay=1" title="YouTube video player" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowFullScreen></iframe></div>
                </div>
                <div style={{width:"max-content", padding:"12px 16px", color:"white", background:"#3947A8", borderRadius:"8px", margin:"auto"}} >
                    <a href="/Onboarding/EngageAI/OptimizeYourNurturingEfforts" style={{color:"white", textDecoration:"none"}} onClick={trackEvent}>Next <img src='/images/right_arrow_white.svg' alt=''></img></a>
                </div>
            </div>
        </div>
        </div>
    );
}
export default EngageWithPeopleWhoMatter;